export type Language = 'en' | 'es';

export interface NavItem {
  label: string;
  path: string;
}

export interface Testimonial {
  id: string;
  quote: string;
  author: string;
  role: string;
  type: 'PCP' | 'Office Manager' | 'Care Coordinator';
}

export interface QuizQuestion {
  id: number;
  question: string;
  options: {
    label: string;
    value: string;
    score: Partial<QuizScore>;
  }[];
}

export interface QuizScore {
  riskTolerance: number;
  adminBurden: number;
  infrastructure: number;
}

export enum QuizResultType {
  FFS_WARRIOR = 'FFS_WARRIOR',
  UPSIDE_SAVER = 'UPSIDE_SAVER',
  RISK_READY = 'RISK_READY',
  BLACK_BOX_VICTIM = 'BLACK_BOX_VICTIM',
}

export interface QuizResult {
  type: QuizResultType;
  title: string;
  description: string;
  painPoints: string[];
  suncoastFix: string;
}

export interface BlogPost {
  id: string;
  title: string;
  category: string;
  readTime: string;
}
